/**
 * Shamelessy copied from Angular UI.
 * https://github.com/angular-ui/ui-utils/blob/master/modules/reset/reset.js
 *
 * Add a clear button to form inputs to reset their value
 */
angular.module('jv.Common.Directives.Reset', [])

.directive('jvReset', [function () {
	var resetValue;
	return {
		require: 'ngModel',
		link: function (scope, elm, attrs, ctrl) {
			var aElement;
			aElement = angular.element('<a class="jv-reset icon blue-icon-clear-input icon-close-circle dark-sec small" />');
			elm.wrap('<span class="jv-resetwrap" />').after(aElement);
			// remove old blue icon class if using new icon font
			if (aElement.css('font-family') === 'jobvite-icons') {
				aElement.removeClass('blue-icon-clear-input');
			}
			aElement[(parseFloat(jQuery.fn.jquery) <= 1.3 ? 'bind' : 'on')]('click', function (e) {
				e.preventDefault();
				scope.$apply(function () {
					if (attrs.jvReset){
						ctrl.$setViewValue(scope.$eval(attrs.jvReset));
					}else{
						ctrl.$setViewValue(resetValue);
					}
					ctrl.$render();
				});
			});
			scope.$watch(attrs.ngModel, function(val) {
				if (val) {
					aElement.show();
				}
				else {
					aElement.hide();
				}
			});
		}
	};
}]);